export default __webpack_public_path__ + "static/media/goal_ai_recommendation.a985a00d.svg";